/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValoreStoricoDTO } from './valore-storico-dto';


export interface StoricoValoreADataDTO { 
    target?: StoricoValoreADataDTOTargetEnum;
    identificatore?: string;
    etichetta?: string;
    presente?: boolean;
    valore?: ValoreStoricoDTO;
}
export enum StoricoValoreADataDTOTargetEnum {
    PRATICA_ROOT = 'PRATICA_ROOT',
    ANAGRAFICA = 'ANAGRAFICA',
    COMPONENTE = 'COMPONENTE',
    EAV = 'EAV'
};



